import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getEventStatus',
  standalone: true,
})
export class GetEventStatusPipe implements PipeTransform {

  transform(eventStatus?: string): string {
    switch(eventStatus) {
      case 'Open': return '';
      case 'Closed': return 'C';
      case 'Post': return 'C';
      case 'Final': return 'F';
      case 'Cancelled': return 'C';
      default: return '';
    }
  }

}
